/**
 * 跳转限制类型枚举
 */
export enum JumpLimitType {
  /** 不限制 */
  NoLimit = 0,
  /** 仅符合人群条件 */
  MatchedOnly = 1,
}

/**
 * 任务类型枚举
 */
export enum TaskType {
  /** 免费赠送 */
  Free = 1,
  /** 充电订单 */
  ChargingOrder = 2,
  /** 充电度数 */
  ChargingAmount = 3,
  /** 分享 */
  Share = 4,
}
